import { useIsMobile } from '../../hook/useIsMobile';
import { WaringModalPc } from './WaringModal/WaringModal.pc';
import { WaringModalMobile } from './WaringModal/WaringModal.mobile';

export type WaringModalViewProps = {
  visible?: boolean;
  close?: () => void;
};

export const WaringModal = (props: WaringModalViewProps) => {
  const isMobile = useIsMobile();
  return isMobile ? <WaringModalMobile {...props} /> : <WaringModalPc {...props} />;
};
